import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Button,
  Divider,
  List,
  ListItemButton,
  TextField,
  Typography,
  Grid,
  IconButton,
  Snackbar,
  Alert,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
  Chip,
  InputAdornment,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
  FormGroup,
  Checkbox,
} from "@mui/material";
import {
  Discount,
  Folder,
  Groups2,
  Handshake,
  LocalOffer,
  Person,
} from "@mui/icons-material";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PhotoIcon from "@mui/icons-material/Photo";
import TitleIcon from "@mui/icons-material/Title";
import CategoryIcon from "@mui/icons-material/Category";
import TypeIcon from "@mui/icons-material/DisplaySettings";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DescriptionIcon from "@mui/icons-material/Description";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import AirlineSeatReclineExtraIcon from "@mui/icons-material/AirlineSeatReclineExtra";
import PendingIcon from "@mui/icons-material/Pending";
import SquareFootIcon from "@mui/icons-material/SquareFoot";
import { Visibility } from "@mui/icons-material";
import { useProperty } from "../../../context/PropertyContext";
import { MapContainer, TileLayer } from "react-leaflet";
import { LatLngTuple } from "leaflet";
import { MapComponent } from "../publish-property-children/PublishLocationPage";
import axios from "axios";
import { useCurrency } from "../../../context/CurrencyContext";
import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
} from "react-beautiful-dnd";
import { getAllHunters } from "../../../services/hunterService";
import { calcZone } from "../publish-property-children/PublishLocationPage";
import CustomAppBar from "../../../components/shared/CustomAppBar";
import DocumentsScreen from "../../../components/publishProperty/screen/DocumentsScreen";
import {
  updateHouseAddress,
  updateCadastralReference,
  updateHasDebts,
  updateMunicipalTaxesStatus,
  updatePreferredSaleMethod,
  updateBankName,
  updateCommissionPercentage,
  UpdateCadastralReferenceData,
} from "../../../services/documentsService";
import { CollaborationRequestsSection } from "../publish-property-children/CollaborationRequestsSection";
import { RealtorCollaborationRequest } from "../../../types/realtorCollaborationRequest";
import { getByPropertyId } from "../../../services/realtorCollaborationRequestsService";
import { EditCommissionPage } from "../publish-property-children/EditCommissionPage";
import { PropertyOfferPage } from "../publish-property-children/PropertyOfferPage";
import { categories, services, amenities } from "../../../utils/PropertyUtils";
import { PropertyCouponPage } from "../publish-property-children/PropertyCouponPage";

interface PublicationData {
  code: string;
  title: string;
  category: string;
  type: string;
  dimension: number;
  details: string;
  description: string;
  services: string;
  amenities: string;
  price: number;
  addressDescription: string;
  photos: string[];
  moduleStateId: number;
  statusCode: string;
  statusColor: string;
  visibility: string;
  hunter: number | null;
  hunterFullName: string | null;
  currency: string;
  facebookUrl: string | null;
  instagramUrl: string | null;
}

interface AddressDetails {
  country: string;
  province: string;
  county: string;
  district: string;
  streetAddress: string;
  postalCode: string;
  nearbyLandmark: string;
  apartment: string;
  googleMapsUrl: string;
  latitude: number;
  longitude: number;
  zone?: string;
  neighborhood?: string;
}

const fieldMap: Record<string, string> = {
  Fotos: "photos",
  Título: "title",
  Descripción: "description",
  Categoría: "category",
  Tipo: "type",
  Ubicación: "location",
  Precio: "price",
  Servicios: "services",
  Amenidades: "amenities",
  Dimensión: "dimension",
  Estado: "status",
  Visibilidad: "visibility",
  Hunter: "hunter",
  Commission: "commission",
  currency: "currency",
  "Redes sociales": "social-url",
  "Documentos y Dueños": "documents",
  "Solicitudes de colaboración": "collaboration-requests",
};

const defaultCoordinates: LatLngTuple = [40.7128, -74.006];
const MIN_PRICE_CRC = 5000;
const MAX_PRICE_CRC = 50000000000;
const MIN_PRICE_USD = 10;
const MAX_PRICE_USD = 1000000000;


const getCostaRicaDistrictDetails = async (lat: number, lng: number) => {
  try {
    const nominatimResponse = await axios.get(
      "https://nominatim.openstreetmap.org/reverse",
      {
        params: {
          lat: lat,
          lon: lng,
          format: "json",
          addressdetails: 1,
          countrycodes: "cr",
          zoom: 18,
          "accept-language": "es",
        },
        headers: {
          "User-Agent": "PropertyApp/1.0",
        },
      }
    );

    const address = nominatimResponse.data.address || {};

    const neighborhood =
      address.neighbourhood || address.suburb || address.city_district || "";

    const nominatimDistrict =
      address.city || address.village || address.town || address.district || "";

    const overpassQuery = `
      [out:json];
      is_in(${lat},${lng})->.a;
      area.a["admin_level"="8"]["boundary"="administrative"];
      out body;
      out tags;
    `;

    const overpassResponse = await axios.post(
      "https://overpass-api.de/api/interpreter",
      overpassQuery,
      {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }
    );

    let districtName = "";
    let cantonName = "";
    let provinceName = "";

    if (
      overpassResponse.data &&
      overpassResponse.data.elements &&
      overpassResponse.data.elements.length > 0
    ) {
      const elements = overpassResponse.data.elements;

      const districtElement = elements.find(
        (el: any) =>
          el.tags &&
          el.tags.admin_level === "8" &&
          el.tags.boundary === "administrative"
      );

      if (districtElement && districtElement.tags) {
        districtName =
          districtElement.tags.name || districtElement.tags["name:es"] || "";
      }

      const cantonQuery = `
        [out:json];
        is_in(${lat},${lng})->.a;
        area.a["admin_level"="6"]["boundary"="administrative"];
        out body;
        out tags;
      `;

      const cantonResponse = await axios.post(
        "https://overpass-api.de/api/interpreter",
        cantonQuery,
        {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        }
      );

      if (
        cantonResponse.data &&
        cantonResponse.data.elements &&
        cantonResponse.data.elements.length > 0
      ) {
        const cantonElement = cantonResponse.data.elements.find(
          (el: any) =>
            el.tags &&
            el.tags.admin_level === "6" &&
            el.tags.boundary === "administrative"
        );

        if (cantonElement && cantonElement.tags) {
          cantonName =
            cantonElement.tags.name || cantonElement.tags["name:es"] || "";
        }
      }

      const provinceQuery = `
        [out:json];
        is_in(${lat},${lng})->.a;
        area.a["admin_level"="4"]["boundary"="administrative"];
        out body;
        out tags;
      `;

      const provinceResponse = await axios.post(
        "https://overpass-api.de/api/interpreter",
        provinceQuery,
        {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        }
      );

      if (
        provinceResponse.data &&
        provinceResponse.data.elements &&
        provinceResponse.data.elements.length > 0
      ) {
        const provinceElement = provinceResponse.data.elements.find(
          (el: any) =>
            el.tags &&
            el.tags.admin_level === "4" &&
            el.tags.boundary === "administrative"
        );

        if (provinceElement && provinceElement.tags) {
          provinceName =
            provinceElement.tags.name || provinceElement.tags["name:es"] || "";
        }
      }
    }

    const finalDistrict = districtName || nominatimDistrict;

    return {
      ...address,
      district: finalDistrict,
      county: cantonName || address.county || address.municipality || "",
      province: provinceName || address.state || address.province || "",
      neighborhood: neighborhood,
    };
  } catch (error) {
    console.error("Error obteniendo detalles del distrito:", error);
    return {};
  }
};

const EditPublication = () => {
  const { selectedProperty, updateProperty, handleSetSelectedProperty } =
    useProperty();
  const [selectedSection, setSelectedSection] = useState("Fotos");
  const [isLoading, setIsLoading] = useState(false);
  const [hasChanged, setHasChanged] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<
    "success" | "error" | "info"
  >("info");
  const [selectedLocation, setSelectedLocation] =
    useState<LatLngTuple>(defaultCoordinates);
  const [isEditing, setIsEditing] = useState(false);
  const [propertyPrice, setPropertyPrice] = useState<string>(
    selectedProperty!.price.toString()
  );
  const { sellRate, buyRate } = useCurrency();
  const [documentData, setDocumentData] = useState<any>(null);
  const [documentChanges, setDocumentChanges] = useState<any>({});
  const [documentValidationErrors, setDocumentValidationErrors] = useState<any>(
    {}
  );
  const [showDocumentValidation, setShowDocumentValidation] = useState(false);
  const [collaborationRequests, setCollaborationRequests] = useState<
    RealtorCollaborationRequest[]
  >([]);
  const [propertyCurrency, setPropertyCurrency] = useState<string>(
    selectedProperty?.currency ?? "CRC"
  );
  const [soldByPublisher, setSoldByPublisher] = useState<boolean | null>(null);
  const [publicationData, setPublicationData] = useState<PublicationData>({
    code: "",
    title: "",
    category: "",
    type: "",
    dimension: 0,
    details: "",
    description: "",
    services: "",
    amenities: "",
    price: 0,
    addressDescription: "",
    photos: [],
    moduleStateId: 0,
    statusCode: "",
    statusColor: "",
    visibility: "",
    hunter: 0,
    hunterFullName: "",
    currency: "",
    facebookUrl: null,
    instagramUrl: null,
  });
  const [addressDetails, setAddressDetails] = useState<AddressDetails>({
    country: "",
    province: "",
    county: "",
    apartment: "",
    district: "",
    streetAddress: "",
    postalCode: "",
    nearbyLandmark: "",
    googleMapsUrl: "",
    latitude: 0,
    longitude: 0,
    zone: "",
    neighborhood: "",
  });
  const [availableHunters, setAvailableHunters] = useState<any[]>([]);
  const [isLoadingHunters, setIsLoadingHunters] = useState(false);
  const [formValues, setFormValues] = useState(addressDetails);
  const [readOnlyState, setReadOnlyState] = useState({
    country: true,
    streetAddress: addressDetails.streetAddress.trim() !== "" ? true : false,
    province: true,
    county: true,
    district: true,
    neighborhood: true,
    postalCode: true,
    zone: true,
  });
  useEffect(() => {
    setFormValues(addressDetails);
    setReadOnlyState({
      country: true,
      streetAddress: addressDetails.streetAddress.trim() !== "" ? true : false,
      province: true,
      county: true,
      district: true,
      neighborhood: true,
      postalCode: true,
      zone: true,
    });
  }, [addressDetails]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const [oldPhotos, setOldPhotos] = useState<string[]>(
    selectedProperty!.photos
  );
  const [deletedPhotos, setDeletedPhotos] = useState<string[]>([]);
  const [newPhotos, setNewPhotos] = useState<File[]>([]);

  const extractNeighborhoodFromAddress = (
    addressDescription: string | undefined
  ): string => {
    if (!addressDescription) return "";

    const addressParts = addressDescription.split(",");
    const barrioPattern = /Barrio\s+([^,]+)/i;

    for (const part of addressParts) {
      const match = part.trim().match(barrioPattern);
      if (match) {
        return match[1].trim();
      }
    }

    return "";
  };

  const fetchCollaborationRequests = useCallback(async () => {
    try {
      const response = await getByPropertyId(
        selectedProperty?.id_Property as number
      );
      if (response.success) {
        setCollaborationRequests(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching collaboration requests:", error);
    }
  }, [selectedProperty]);

  useEffect(() => {
    fetchCollaborationRequests();
  }, [fetchCollaborationRequests, selectedProperty]);


  const pendingCollaborationRequest = collaborationRequests.filter(
    (request) => request.status === 0
  );

  const onPromotionUpdate = (promotion: any) => {
      selectedProperty!.price = promotion ? promotion.newPrice : selectedProperty!.price;
      selectedProperty!.promotion = promotion;
      setPublicationData((prev) => ({
        ...prev,
        price: promotion ? promotion.newPrice : prev.price,
        promotion: promotion,
      }));
      handleSetSelectedProperty(selectedProperty);
    }

  useEffect(() => {
    const fetchAddressDetails = async (lat: number, lng: number) => {
      try {
        const response = await axios.get(
          "https://nominatim.openstreetmap.org/reverse",
          {
            params: {
              lat: lat,
              lon: lng,
              format: "json",
              addressdetails: 1,
            },
          }
        );
        const address = response.data.address || {};

        const zoneValue = selectedProperty?.zone || calcZone(lat, lng);

        const districtValue =
          address.village ||
          address.suburb ||
          address.district ||
          selectedProperty?.district ||
          "";

        const newAddressDetails = {
          country: address.country || "",
          province: address.province || "",
          county: address.county || "",
          apartment: address.apartment || "",
          district: districtValue,
          streetAddress: address.road || "",
          postalCode: address.postcode || "",
          nearbyLandmark: address.landmark || "",
          googleMapsUrl: `https://www.google.com/maps?q=${lat},${lng}`,
          latitude: lat,
          longitude: lng,
          zone: zoneValue,
          neighborhood:
            address.neighborhood ||
            extractNeighborhoodFromAddress(
              selectedProperty?.address_Description
            ) ||
            "",
        };

        setAddressDetails(newAddressDetails);

        setFormValues({
          ...newAddressDetails,
          nearbyLandmark: address.landmark || "",
          apartment: address.apartment || "",
        });
      } catch (error) {
        console.error("Error fetching address details:", error);
      }
    };

    if (selectedProperty) {
      const numericValue = Number.parseFloat(
        selectedProperty.dimension.slice(0, -2)
      );
      setPublicationData({
        code: selectedProperty.code || "",
        title: selectedProperty.title || "",
        category: selectedProperty.categoryName || "",
        type: selectedProperty.modeDescription,
        dimension: numericValue,
        details: selectedProperty.details || "",
        description: selectedProperty.description || "",
        services: selectedProperty.services || "",
        amenities: selectedProperty.amenities || "",
        price: selectedProperty.price || 0,
        addressDescription: selectedProperty.address_Description || "",
        photos: selectedProperty.photos || [],
        moduleStateId: selectedProperty.moduleStateId,
        statusCode: selectedProperty?.statusCode || "",
        statusColor: selectedProperty.statusColor || "",
        visibility: selectedProperty.visibility || "",
        hunter: selectedProperty.id_Hunter || 0,
        hunterFullName: selectedProperty.hunterFullName || null,
        currency: selectedProperty.currency || "",
        facebookUrl: selectedProperty.facebookUrl,
        instagramUrl: selectedProperty.instagramUrl,
      });

      setNewPhotos([]);
      setDeletedPhotos([]);
      setOldPhotos(selectedProperty.photos || []);

      if (selectedProperty.latitude && selectedProperty.longitude) {
        const lat = Number.parseFloat(selectedProperty.latitude);
        const lng = Number.parseFloat(selectedProperty.longitude);
        setSelectedLocation([lat, lng]);

        fetchAddressDetails(lat, lng);
      } else {
        // Si no hay coordenadas, al menos extraer el barrio de la dirección
        if (selectedProperty?.address_Description) {
          const neighborhoodValue = extractNeighborhoodFromAddress(
            selectedProperty.address_Description
          );

          if (neighborhoodValue) {
            setAddressDetails((prev) => ({
              ...prev,
              neighborhood: neighborhoodValue,
            }));
            setFormValues((prev) => ({
              ...prev,
              neighborhood: neighborhoodValue,
            }));
          }
        }
      }
    }
  }, [selectedProperty]);

  useEffect(() => {
    if (selectedSection === "Hunter") {
      const fetchHunters = async () => {
        setIsLoadingHunters(true);
        try {
          const token = localStorage.getItem("authToken");
          if (token) {
            const huntersData = await getAllHunters(token);
            setAvailableHunters(huntersData || []);
          }
        } catch (error) {
          console.error("Failed to fetch hunters:", error);
        } finally {
          setIsLoadingHunters(false);
        }
      };

      fetchHunters();
    }
  }, [selectedSection]);

  const handleSelectSection = (section: string) => {
    setSelectedSection(section);

    const numericValue = parseFloat(selectedProperty!.dimension.slice(0, -2));

    setPublicationData({
      code: selectedProperty!.code || "",
      title: selectedProperty!.title || "",
      category: selectedProperty!.categoryName || "",
      type: selectedProperty!.modeDescription || "",
      dimension: numericValue,
      details: selectedProperty!.details || "",
      description: selectedProperty!.description || "",
      services: selectedProperty!.services || "",
      amenities: selectedProperty!.amenities || "",
      price: selectedProperty!.price || 0,
      addressDescription: selectedProperty!.address_Description || "",
      photos: selectedProperty!.photos || [],
      moduleStateId: selectedProperty!.moduleStateId,
      statusCode: selectedProperty?.statusCode || "",
      statusColor: selectedProperty?.statusColor || "",
      visibility: selectedProperty?.visibility || "",
      hunter: selectedProperty?.id_Hunter || 0,
      hunterFullName: selectedProperty?.hunterFullName || null,
      currency: selectedProperty?.currency || "",
      facebookUrl: selectedProperty?.facebookUrl!,
      instagramUrl: selectedProperty?.instagramUrl!,
    });
    setOldPhotos(selectedProperty!.photos || []);
    setNewPhotos([]);
    setDeletedPhotos([]);
    setPropertyPrice(selectedProperty!.price.toString());
    setPropertyCurrency(selectedProperty!.currency ?? "CRC");
  };

  useEffect(() => {
    if (selectedProperty!.latitude && selectedProperty!.longitude) {
      setSelectedLocation([
        parseFloat(selectedProperty!.latitude),
        parseFloat(selectedProperty!.longitude),
      ]);
    }
  }, [selectedProperty]);

  const handlePhotoDelete = (index: number) => {
    const photoToDelete = oldPhotos[index];
    if (
      !newPhotos.some((file) => URL.createObjectURL(file) === photoToDelete)
    ) {
      setDeletedPhotos([...deletedPhotos, photoToDelete]);
    }
    setOldPhotos(oldPhotos.filter((_, i) => i !== index));
  };

  const handleDeleteNewPhoto = (photo: File) => {
    setNewPhotos(newPhotos.filter((newPhoto) => newPhoto !== photo));
  };

  const handlePhotoUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files || []);
    setNewPhotos([...newPhotos, ...files]);
  };

  const handleOnDragEnd = (result: DropResult) => {
    if (!result.destination) return;

    const { source, destination } = result;
    if (source.index === destination.index) return;

    const updatedPhotos = oldPhotos;
    const [movedPhoto] = updatedPhotos.splice(source.index, 1);
    updatedPhotos.splice(destination.index, 0, movedPhoto);

    setOldPhotos(updatedPhotos);
    setHasChanged(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleStatusChange = (event: any) => {
    const selectedStatus = event.target.value;

    let newStatusColor = publicationData.statusColor;
    let selectedModuleStateId = publicationData.moduleStateId;

    if (selectedStatus === "Disponible") {
      selectedModuleStateId = 1;
      newStatusColor = "#008000";
      setSoldByPublisher(null);
    } else if (selectedStatus === "Vendida") {
      selectedModuleStateId = 2;
      newStatusColor = "#FF0000";
      setSoldByPublisher(true); // ejemplo
    } else if (selectedStatus === "Alquilada") {
      selectedModuleStateId = 3;
      newStatusColor = "#FF0000";
      setSoldByPublisher(true); // ejemplo
    }

    setPublicationData({
      ...publicationData,
      moduleStateId: selectedModuleStateId,
      statusCode: selectedStatus,
      statusColor: newStatusColor,
    });
  };

  const handleVisibilityChange = (event: any) => {
    const selectedVisibility = event.target.value;

    setPublicationData({
      ...publicationData,
      visibility: selectedVisibility,
    });
  };

  const handlePriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    setPropertyPrice(value);

    if (propertyCurrency === "USD") {
      // Permitimos solo 2 decimales para Dólares
      value = value.replace(/[^0-9.]/g, ""); // Permitimos solo números y punto
      const decimalCount = (value.match(/\./g) || []).length;
      if (decimalCount > 1) {
        // Si hay más de un punto decimal, eliminamos el último
        value =
          value.substring(0, value.lastIndexOf(".")) +
          value.substring(value.lastIndexOf(".") + 1);
      }
      const parts = value.split(".");
      if (parts.length > 1 && parts[1].length > 2) {
        // Limitar a dos decimales
        value = `${parts[0]}.${parts[1].substring(0, 2)}`;
      }
    } else {
      // Para Colones, solo permitimos números enteros
      value = value.replace(/\D/g, "");
    }

    setPropertyPrice(value);
  };

  const handleBlur = () => {
    const numericPrice = Number.parseInt(propertyPrice);
    const minPrice = propertyCurrency === "USD" ? MIN_PRICE_USD : MIN_PRICE_CRC;
    const maxPrice = propertyCurrency === "USD" ? MAX_PRICE_USD : MAX_PRICE_CRC;

    if (numericPrice < minPrice) {
      setPropertyPrice(minPrice.toString());
    } else if (numericPrice > maxPrice) {
      setPropertyPrice(maxPrice.toString());
    }
    setIsEditing(false);
  };

  const handleCurrencyChange = (event: SelectChangeEvent<string>) => {
    const newCurrency = event.target.value;
    const currentPrice = Number.parseFloat(propertyPrice || "0");

    if (propertyCurrency !== newCurrency && sellRate && buyRate) {
      let convertedPrice = currentPrice;

      if (newCurrency === "USD") {
        convertedPrice = Math.round(currentPrice / sellRate);
      } else if (newCurrency === "CRC") {
        convertedPrice = Math.round(currentPrice * buyRate);
      }

      setPropertyPrice(convertedPrice.toString());
    }
    setPropertyCurrency(newCurrency);
    setPublicationData((prev) => ({ ...prev, currency: newCurrency }));
  };

  const toggleEditing = () => {
    setIsEditing(!isEditing);
  };

  const formatPrice = (price: string, propertyCurrency: string) => {
    const numericPrice = Number.parseFloat(price) || 0;
    const formattedPrice = numericPrice.toFixed(2);

    return propertyCurrency === "USD"
      ? `$${Number.parseFloat(formattedPrice).toLocaleString("en-US")}`
      : `₡${Number.parseFloat(formattedPrice).toLocaleString("es-CR")}`;
  };

  const handleToggleService = (serviceId: string) => {
    setPublicationData((prevData) => {
      const currentServices = prevData.services
        ? prevData.services.split(", ")
        : [];

      const isSelected = currentServices.includes(serviceId);

      const updatedServices = isSelected
        ? currentServices.filter((id) => id !== serviceId)
        : [...currentServices, serviceId];

      return {
        ...prevData,
        services: updatedServices.join(", "),
      };
    });
  };

  const handleToggleAmenitie = (amenitieId: string) => {
    setPublicationData((prevData) => {
      const currentAmenities = prevData.amenities
        ? prevData.amenities.split(", ")
        : [];

      const isSelected = currentAmenities.includes(amenitieId);

      const updatedAmenities = isSelected
        ? currentAmenities.filter((id) => id !== amenitieId)
        : [...currentAmenities, amenitieId];

      return {
        ...prevData,
        amenities: updatedAmenities.join(", "),
      };
    });
  };

  const handleHunterChange = (event: SelectChangeEvent<number>) => {
    const selectedHunterId = Number(event.target.value);
    const selectedHunter = availableHunters.find(
      (h) => h.id === selectedHunterId
    );

    setPublicationData({
      ...publicationData,
      hunter: selectedHunterId,
      hunterFullName: selectedHunter
        ? selectedHunter.contacts?.fullName || `Hunter ${selectedHunterId}`
        : null,
    });
  };

  const handleDocumentDataChange = (data: any) => {
    setDocumentChanges(data);
    if (!documentData) {
      setDocumentData(data);
    }
  };

  const validateDocumentSection = (): boolean => {
    const errors: any = {};
    let hasErrors = false;

    // Validar que existe documentData o documentChanges
    if (!documentData && !documentChanges.id) {
      errors.general = "Debe crear un documento antes de guardar";
      hasErrors = true;
    }

    // Validar campos específicos si existen cambios
    if (
      documentChanges.houseAddress !== undefined &&
      !documentChanges.houseAddress?.trim()
    ) {
      errors.houseAddress = "La dirección es requerida";
      hasErrors = true;
    }

    if (
      documentChanges.municipalTaxesStatus !== undefined &&
      !documentChanges.municipalTaxesStatus?.trim()
    ) {
      errors.municipalTaxesStatus = "El estado de impuestos es requerido";
      hasErrors = true;
    }

    if (
      documentChanges.bankName !== undefined &&
      !documentChanges.bankName?.trim()
    ) {
      errors.bankName = "El banco es requerido";
      hasErrors = true;
    }

    if (
      documentChanges.commissionPercentage !== undefined &&
      (!documentChanges.commissionPercentage ||
        documentChanges.commissionPercentage <= 0)
    ) {
      errors.commissionPercentage =
        "El porcentaje de comisión debe ser mayor a 0";
      hasErrors = true;
    }

    setDocumentValidationErrors(errors);
    setShowDocumentValidation(hasErrors);

    return !hasErrors;
  };

  const handleSaveChanges = async () => {
    setIsLoading(true);

    if (
      selectedSection === "Fotos" &&
      oldPhotos.length + newPhotos.length < 5
    ) {
      handleSelectSection("Fotos");
      setSnackbarMessage("Debe haber un mínimo de 5 fotos.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      setIsLoading(false);
      return;
    }

    if (selectedSection === "Documentos y Dueños") {
      if (!validateDocumentSection()) {
        setSnackbarMessage(
          "Por favor, completa todos los campos requeridos en la sección de documentos."
        );
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setIsLoading(false);
        return;
      }
      try {
        if (documentChanges.houseAddress !== undefined) {
          const addressFormData = new FormData();
          addressFormData.append(
            "DocumentId",
            documentChanges.id?.toString() || ""
          );
          addressFormData.append(
            "HouseAddress",
            documentChanges.houseAddress || ""
          );
          await updateHouseAddress(addressFormData);
        }

        if (
          documentChanges.cadastralReference !== undefined ||
          documentChanges.hasImagePending
        ) {
          const updateData: UpdateCadastralReferenceData = {
            documentId: Number(documentChanges.id) || 0,
            cadastralReference: documentChanges.hasImagePending
              ? ""
              : documentChanges.cadastralReference || "",
          };
          await updateCadastralReference(updateData);
        }

        if (documentChanges.hasDebts !== undefined) {
          const debtsFormData = new FormData();
          debtsFormData.append(
            "DocumentId",
            documentChanges.id?.toString() || ""
          );
          debtsFormData.append(
            "HasDebts",
            documentChanges.hasDebts ? "true" : "false"
          );
          await updateHasDebts(debtsFormData);
        }

        if (documentChanges.municipalTaxesStatus !== undefined) {
          const taxesFormData = new FormData();
          taxesFormData.append(
            "DocumentId",
            documentChanges.id?.toString() || ""
          );
          taxesFormData.append(
            "MunicipalTaxesStatus",
            documentChanges.municipalTaxesStatus || ""
          );
          await updateMunicipalTaxesStatus(taxesFormData);
        }

        if (documentChanges.preferredSaleMethod !== undefined) {
          const methodFormData = new FormData();
          methodFormData.append(
            "DocumentId",
            documentChanges.id?.toString() || ""
          );
          methodFormData.append(
            "PreferredSaleMethod",
            documentChanges.preferredSaleMethod || ""
          );
          await updatePreferredSaleMethod(methodFormData);
        }

        if (documentChanges.bankName !== undefined) {
          const bankFormData = new FormData();
          bankFormData.append(
            "DocumentId",
            documentChanges.id?.toString() || ""
          );
          bankFormData.append("BankName", documentChanges.bankName || "");
          await updateBankName(bankFormData);
        }

        if (documentChanges.commissionPercentage !== undefined) {
          const commissionFormData = new FormData();
          commissionFormData.append(
            "DocumentId",
            documentChanges.id?.toString() || ""
          );
          commissionFormData.append(
            "CommissionPercentage",
            documentChanges.commissionPercentage?.toString() || "0"
          );
          await updateCommissionPercentage(commissionFormData);
        }

        setPublicationData((prevData) => ({
          ...prevData,
          snackbarMessage: "Documentos actualizados exitosamente.",
          snackbarSeverity: "success",
          snackbarOpen: true,
        }));

        setDocumentChanges({});
      } catch (error) {
        console.error("❌ Error al actualizar documentos:", error);
        setPublicationData((prevData) => ({
          ...prevData,
          snackbarMessage: "Error al actualizar documentos.",
          snackbarSeverity: "error",
          snackbarOpen: true,
        }));
      }

      setIsLoading(false);
      return;
    }

    const field = fieldMap[selectedSection];
    if (!field) {
      console.error(
        `No se encontró un campo válido para la sección: ${selectedSection}`
      );
      setIsLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("PropertyId", selectedProperty!.id_Property.toString());

    switch (selectedSection) {
      case "Fotos":
        newPhotos.forEach((photo) => formData.append("NewPhotos", photo));
        deletedPhotos.forEach((photo) =>
          formData.append("DeletedPhotos", photo)
        );
        if (hasChanged)
          oldPhotos.forEach((photo) =>
            formData.append("ReorderedPhotos", photo)
          );
        break;
      case "Título":
        formData.append("PropertyTitle", publicationData.title);
        break;
      case "Descripción":
        formData.append("PropertyDescription", publicationData.description);
        break;
      case "Categoría":
        formData.append("PropertyCategory", publicationData.category);
        break;
      case "Tipo":
        formData.append("PropertyType", publicationData.type);
        break;
      case "Ubicación":
        const fullAddressString = [
          formValues.streetAddress,
          formValues.apartment,
          formValues.district,
          formValues.neighborhood ? `Barrio ${formValues.neighborhood}` : "",
          formValues.postalCode,
          formValues.county,
          formValues.province,
          formValues.country,
          formValues.zone,
          formValues.nearbyLandmark,
        ]
          .filter(Boolean)
          .join(", ");

        formData.append("PropertyAddressDetails", fullAddressString);
        formData.append("PropertyLatitude", formValues.latitude.toString());
        formData.append("PropertyLongitude", formValues.longitude.toString());
        formData.append("County", formValues.county || "");
        formData.append("District", formValues.district || "");
        formData.append("Neighborhood", formValues.neighborhood || "");
        formData.append("Zone", formValues.zone || "");
        break;
      case "Precio":
        formData.append("PropertyPrice", propertyPrice);
        formData.append("PropertyCurrency", propertyCurrency);
        break;
      case "Servicios":
        formData.append("PropertyServices", publicationData.services);
        break;
      case "Amenidades":
        formData.append("PropertyAmenities", publicationData.amenities);
        break;
      case "Dimensión":
        formData.append("PropertyDimension", `${publicationData.dimension} m²`);
        break;
      case "Estado":
        formData.append(
          "PropertyModuleState",
          publicationData.moduleStateId.toString()
        );
        if (["Vendida", "Alquilada"].includes(publicationData.statusCode)) {
          formData.append(
            "SoldByPublisher",
            soldByPublisher === true ? "true" : "false"
          );
        } else {
          formData.append("SoldByPublisher", "");
        }
        break;
      case "Visibilidad":
        formData.append("PropertyVisibility", publicationData.visibility);
        break;
      case "Hunter":
        formData.append("PropertyId", selectedProperty!.id_Property.toString());
        formData.append("HunterId", publicationData.hunter!.toString());
        break;
      case "Redes sociales":
        if (publicationData.facebookUrl?.trim()) {
          formData.append("PropertyFacebookUrl", publicationData.facebookUrl);
        }
        if (publicationData.instagramUrl?.trim()) {
          formData.append("PropertyInstagramUrl", publicationData.instagramUrl);
        }
        break;
      default:
        setIsLoading(false);
        return;
    }

    try {
      await updateProperty(field, formData);
      setSnackbarMessage(`${selectedSection} actualizada exitosamente.`);
      setSnackbarSeverity("success");

      if (selectedSection === "Ubicación" && selectedProperty) {
        const fullAddressString = [
          formValues.streetAddress,
          formValues.apartment,
          formValues.district,
          formValues.neighborhood ? `Barrio ${formValues.neighborhood}` : "",
          formValues.postalCode,
          formValues.county,
          formValues.province,
          formValues.country,
          formValues.zone,
          formValues.nearbyLandmark,
        ]
          .filter(Boolean)
          .join(", ");

        const updatedProperty = {
          ...selectedProperty,
          address_Description: fullAddressString,
          latitude: formValues.latitude.toString(),
          longitude: formValues.longitude.toString(),
          county: formValues.county || "",
          district: formValues.district || "",
          neighborhood: formValues.neighborhood || "",
          zone: formValues.zone || "",
        };

        handleSetSelectedProperty(updatedProperty);

        setPublicationData((prevData) => ({
          ...prevData,
          addressDescription: fullAddressString,
        }));
      }

      if (selectedSection === "Hunter" && publicationData.hunter) {
        const selectedHunter = availableHunters.find(
          (h) => h.id === publicationData.hunter
        );
        if (selectedHunter) {
          const hunterName =
            selectedHunter.contacts?.fullName ||
            `Hunter ${publicationData.hunter}`;

          setPublicationData((prev) => ({
            ...prev,
            hunterFullName: hunterName,
          }));

          if (selectedProperty) {
            const updatedProperty = {
              ...selectedProperty,
              hunterFullName: hunterName,
              id_Hunter: publicationData.hunter,
            };
            handleSetSelectedProperty(updatedProperty);
          }
        }
      }
    } catch (error) {
      console.error(`Error al actualizar ${selectedSection}:`, error);
      setSnackbarMessage(`Error al actualizar ${selectedSection}.`);
      setSnackbarSeverity("error");
    }

    setIsLoading(false);
    setSnackbarOpen(true);
  };

  const handleMarkerDragEnd = async (event: any) => {
    let lat, lng;

    if (Array.isArray(event) && event.length === 2) {
      [lat, lng] = event;
    } else if (
      event &&
      event.target &&
      typeof event.target.getLatLng === "function"
    ) {
      const latLng = event.target.getLatLng();
      lat = latLng.lat;
      lng = latLng.lng;
    } else if (event && event.latlng) {
      lat = event.latlng.lat;
      lng = event.latlng.lng;
    } else if (event && event.lat && event.lng) {
      lat = event.lat;
      lng = event.lng;
    } else {
      console.error("Invalid event structure in handleMarkerDragEnd:", event);
      return;
    }

    setSelectedLocation([lat, lng]);

    try {
      const districtDetails = await getCostaRicaDistrictDetails(lat, lng);

      // Create a complete address details object with all necessary fields
      const updatedAddressDetails = {
        ...addressDetails,
        latitude: lat,
        longitude: lng,
        country: districtDetails.country || addressDetails.country,
        province: districtDetails.province || addressDetails.province,
        county: districtDetails.county || addressDetails.county,
        district: districtDetails.district || addressDetails.district,
        streetAddress: districtDetails.road || addressDetails.streetAddress,
        postalCode: districtDetails.postcode || addressDetails.postalCode,
        neighborhood:
          districtDetails.neighborhood || addressDetails.neighborhood,
        zone:
          districtDetails.zone || addressDetails.zone || selectedProperty?.zone,
        // Preserve user-entered values
        apartment: formValues.apartment,
        nearbyLandmark: formValues.nearbyLandmark,
        googleMapsUrl: `https://www.google.com/maps?q=${lat},${lng}`,
      };

      // Update both state objects with the complete data
      setAddressDetails(updatedAddressDetails);
      setFormValues(updatedAddressDetails);

      // Make sure the readOnly state is updated correctly
      setReadOnlyState({
        country: true,
        streetAddress: updatedAddressDetails.streetAddress.trim() !== "",
        province: true,
        county: true,
        district: true,
        neighborhood: true,
        postalCode: true,
        zone: true,
      });
    } catch (error) {
      console.error("Error al obtener detalles del distrito:", error);
    }
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        mt: 2,
        paddingBottom: 2,
      }}
    >
      {/* AppBar con logo y botón de salida */}
      <CustomAppBar />
      {/* Contenido principal */}
      <Box
        sx={{
          display: "flex",
          flex: 1,
          flexDirection: {
            xs: "column",
            md: "row",
          },
          overflowY: "auto",
        }}
      >
        {/* Sección izquierda (30%) */}
        <Box
          sx={{
            width: {
              xs: "100%",
              md: "35%",
            },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            pt: { xs: 12, md: 15 },
            overflowY: "auto",
            maxHeight: { md: "calc(100vh - 64px)" },
            height: {
              xs: "40%",
              md: "100%",
            },
          }}
        >
          <Typography variant="h5" sx={{ mb: 2, textAlign: "center" }}>
            Editor de Publicación
          </Typography>
          <List component="nav" sx={{ width: "100%" }}>
            {[
              { label: "Fotos", icon: <PhotoIcon /> },
              { label: "Estado", icon: <PendingIcon /> },
              { label: "Título", icon: <TitleIcon /> },
              { label: "Descripción", icon: <DescriptionIcon /> },
              { label: "Categoría", icon: <CategoryIcon /> },
              { label: "Tipo", icon: <TypeIcon /> },
              { label: "Ubicación", icon: <LocationOnIcon /> },
              { label: "Precio", icon: <AttachMoneyIcon /> },
              {label: "Ofertas", icon: <LocalOffer />},
              { label: "Cupones", icon: <Discount /> },
              {label: "Comisión", icon: <Handshake />},
              { label: "Servicios", icon: <HomeRepairServiceIcon /> },
              { label: "Amenidades", icon: <AirlineSeatReclineExtraIcon /> },
              { label: "Dimensión", icon: <SquareFootIcon /> },
              { label: "Visibilidad", icon: <Visibility /> },
              { label: "Hunter", icon: <Person /> },
              { label: "Redes sociales", icon: <Visibility /> },
              { label: "Documentos y Dueños", icon: <Folder /> },
              { label: "Solicitudes de colaboración", icon: <Groups2 /> },
            ].map((section, index) => (
              <ListItemButton
                key={section.label}
                selected={selectedSection === section.label}
                onClick={() => handleSelectSection(section.label)}
                sx={{
                  border: "1px solid #ddd",
                  borderRadius: 2,
                  mx: 6,
                  mb: 2,
                  height: "auto",
                  minHeight: "100px",
                  boxShadow:
                    selectedSection === section.label
                      ? "0 0 10px rgba(0,0,0,0.2)"
                      : "none",
                  backgroundColor:
                    selectedSection === section.label ? "#81c784" : "inherit",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  flexDirection: "row",
                  overflow: "hidden",
                  transition: "background-color 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#d4edda",
                  },
                }}
              >
                {React.cloneElement(section.icon, {
                  fontSize: "large",
                  sx: { mr: 2 },
                })}

                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="h6">{section.label}</Typography>{" "}
                  {/* Texto más grande */}
                  <Typography
                    variant="body1"
                    sx={{
                      color: "gray",
                      textAlign: "left",
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      WebkitLineClamp: 3,
                    }}
                  >
                    {section.label === "Fotos"
                      ? `${selectedProperty!.photos.length} fotos`
                      : section.label === "Estado"
                      ? selectedProperty!.statusCode
                      : section.label === "Título"
                      ? selectedProperty!.title
                      : section.label === "Descripción"
                      ? selectedProperty!.description
                      : section.label === "Categoría"
                      ? selectedProperty!.categoryName
                      : section.label === "Tipo"
                      ? selectedProperty!.modeDescription
                      : section.label === "Ubicación"
                      ? selectedProperty!.address_Description ||
                      selectedProperty!.address_Description ||
                      ""
                      : section.label === "Precio"
                      ? formatPrice(
                        selectedProperty!.price.toString(),
                        propertyCurrency
                      )
                      : section.label === "Ofertas"
                      ? selectedProperty!.promotion?.discountPercentage
                      ? (
                        <span
                          style={{
                          background: "linear-gradient(90deg, #FFD700, #FFA500)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                          fontWeight: "bold",
                          }}
                        >
                          descuento actual: {selectedProperty!.promotion.discountPercentage}% 
                        </span>
                        )
                      : "Sin oferta"
                      : section.label === "Cupones"
                      ? selectedProperty!.coupon?.title
                      : section.label === "Servicios"
                      ? selectedProperty!.services
                      : section.label === "Amenidades"
                      ? selectedProperty!.amenities
                      : section.label === "Dimensión"
                      ? selectedProperty!.dimension
                      : section.label === "Visibilidad"
                      ? selectedProperty!.visibility
                      : section.label === "Hunter"
                      ? selectedProperty!.hunterFullName ||
                      `Hunter ${selectedProperty!.id_Hunter}`
                      : section.label === "Comisión"
                      ? selectedProperty?.commisionType === 1
                      ? "Comisión directa"
                      : selectedProperty?.commisionType === 2
                      ? "Comisión compartida"
                      : "Sin comisión"
                      : section.label === "Redes sociales"
                      ? selectedProperty!.facebookUrl ||
                      selectedProperty!.instagramUrl
                      ? `Facebook: ${
                        selectedProperty!.facebookUrl || "No disponible"
                        }\nInstagram: ${
                        selectedProperty!.instagramUrl || "No disponible"
                        }`
                      : "No hay redes sociales configuradas"
                      : section.label === "Documentos y Dueños"
                      ? selectedProperty!.code
                      : section.label === "Solicitudes de colaboración"
                      ? `(${
                        pendingCollaborationRequest.length || 0
                      }) Solicitudes de colaboración pendientes`
                      : selectedProperty!.price.toLocaleString("en-CR") + " s"}
                  </Typography>
                </Box>
              </ListItemButton>
            ))}
          </List>
        </Box>

        <Divider
          orientation="vertical"
          sx={{
            height: "100%",
            bgcolor: "#ddd",
            display: {
              xs: "none",
              md: "block",
            },
          }}
        />

        {/* Sección derecha (70%) */}
        <Box
          sx={{
            width: { xs: "100%", md: "65%" },
            height: {
              xs: "60%",
              md: "100%",
            },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            pt: { xs: 2, md: 15 },
            borderTop: "1px solid grey",
            overflowY: "auto",
          }}
        >
          {selectedSection === "Fotos" && (
            <>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: {
                    xs: "center",
                    md: "space-around",
                  },
                  flexDirection: {
                    xs: "column",
                    md: "row",
                  },
                  gap: 2, // Espacio entre elementos en vertical
                  width: "100%",
                  textAlign: "center", // Centra el texto en xs
                  mb: 2,
                }}
              >
                <Typography variant="h5">
                  Editar Recorrido Fotográfico
                </Typography>
                <Button
                  variant="text"
                  component="label"
                  startIcon={<AddIcon sx={{ fontSize: 20 }} />}
                >
                  Agregar más
                  <input
                    hidden
                    accept="image/*"
                    multiple
                    type="file"
                    onChange={handlePhotoUpload}
                  />
                </Button>
              </Box>

              {/* Zona de arrastre para las fotos actuales */}
              <DragDropContext onDragEnd={handleOnDragEnd}>
                <Droppable droppableId="oldPhotos" direction="horizontal">
                  {(provided) => (
                    <Grid
                      container
                      spacing={2}
                      justifyContent="start"
                      px={{ xs: 2, md: 8 }}
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                    >
                      {oldPhotos.map((photoUrl, index) => (
                        <Draggable
                          key={photoUrl}
                          draggableId={photoUrl}
                          index={index}
                        >
                          {(provided) => (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={4}
                              sx={{ display: "flex", justifyContent: "center" }}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <Box
                                sx={{
                                  position: "relative",
                                  width: "100%",
                                  maxWidth: "250px",
                                  height: "250px",
                                }}
                              >
                                <img
                                  src={photoUrl}
                                  alt={`Foto ${index + 1}`}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: "8px",
                                    objectFit: "cover",
                                  }}
                                />

                                {index === 0 && (
                                  <Box
                                    sx={{
                                      position: "absolute",
                                      top: 8,
                                      left: 8,
                                      backgroundColor: "rgba(255, 215, 0, 0.8)",
                                      color: "white",
                                      padding: "4px 8px",
                                      borderRadius: "4px",
                                      fontSize: "0.9em",
                                      fontWeight: "bold",
                                      boxShadow:
                                        "0px 4px 8px rgba(0, 0, 0, 0.3)",
                                    }}
                                  >
                                    Principal
                                  </Box>
                                )}

                                <IconButton
                                  onClick={() => handlePhotoDelete(index)}
                                  sx={{
                                    position: "absolute",
                                    top: 8,
                                    right: 8,
                                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                                    "&:hover": {
                                      backgroundColor:
                                        "rgba(255, 255, 255, 0.9)",
                                    },
                                    padding: "4px",
                                  }}
                                >
                                  <DeleteIcon color="error" />
                                </IconButton>
                              </Box>
                            </Grid>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </Grid>
                  )}
                </Droppable>
              </DragDropContext>

              {/* Mostrar las nuevas fotos antes de subir */}
              {newPhotos.length > 0 && (
                <>
                  <Typography variant="h6" sx={{ mt: 4 }}>
                    Fotos Nuevas:
                  </Typography>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="start"
                    px={{ xs: 2, md: 8 }}
                  >
                    {newPhotos.map((photo, index) => (
                      <Grid item xs={12} sm={6} md={4} key={index}>
                        <Box
                          sx={{
                            position: "relative",
                            width: "100%",
                            maxWidth: "250px",
                            height: "250px",
                            margin: "0 auto",
                          }}
                        >
                          <img
                            src={URL.createObjectURL(photo)}
                            alt={`Nueva Foto ${index + 1}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "8px",
                              objectFit: "cover",
                            }}
                          />
                          <IconButton
                            onClick={() => handleDeleteNewPhoto(photo)}
                            sx={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              backgroundColor: "rgba(255, 255, 255, 0.7)",
                              "&:hover": {
                                backgroundColor: "rgba(255, 255, 255, 0.9)",
                              },
                              padding: "4px",
                            }}
                          >
                            <DeleteIcon color="error" />
                          </IconButton>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </>
              )}
            </>
          )}
          {selectedSection === "Estado" && (
            <Box
              sx={{
                width: { xs: "80%", md: "100%" },
                maxWidth: "600px",
                mx: "auto",
                px: { xs: 2, sm: 3, md: 0 },
              }}
            >
              <Typography variant="h5" sx={{ mb: 2 }}>
                Editar Estado
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: "white",
                  borderRadius: "12px",
                  border: "1px solid gray",
                  boxShadow: "0px 4px 8px rgba(0, 128, 0, 0.1)",
                  padding: { xs: 2, sm: 3, md: 4 },
                  mt: 5,
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    mb: 4,
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  Estado actual:{" "}
                  <strong
                    style={{
                      color: publicationData.statusColor,
                    }}
                  >
                    {publicationData.statusCode}
                  </strong>
                </Typography>

                <FormControl component="fieldset" fullWidth>
                  <FormLabel
                    component="legend"
                    sx={{
                      fontWeight: "bold",
                      mb: 2,
                      "&.Mui-focused": {
                        color: "inherit",
                      },
                    }}
                  >
                    Cambiar estado a:
                  </FormLabel>
                  <RadioGroup
                    aria-label="estado-publicacion"
                    value={publicationData.statusCode}
                    onChange={handleStatusChange}
                  >
                    <FormControlLabel
                      value="Disponible"
                      control={
                        <Radio
                          sx={{
                            color: "green",
                            "&.Mui-checked": { color: "green" },
                          }}
                        />
                      }
                      label="Disponible"
                    />
                    <FormControlLabel
                      value="Vendida"
                      control={
                        <Radio
                          sx={{
                            color: "green",
                            "&.Mui-checked": { color: "green" },
                          }}
                        />
                      }
                      label="Vendida"
                      disabled={publicationData.type !== "Venta"}
                    />
                    <FormControlLabel
                      value="Alquilada"
                      control={
                        <Radio
                          sx={{
                            color: "green",
                            "&.Mui-checked": { color: "green" },
                          }}
                        />
                      }
                      label="Alquilada"
                      disabled={publicationData.type !== "Alquiler"}
                    />
                  </RadioGroup>
                  {(publicationData.statusCode === "Vendida" ||
                    publicationData.statusCode === "Alquilada") && (
                    <FormControl fullWidth sx={{ mt: 3 }}>
                      <FormLabel component="legend">
                        ¿La{" "}
                        {publicationData.statusCode === "Vendida"
                          ? "vendiste"
                          : "alquilaste"}{" "}
                        tú?
                      </FormLabel>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={soldByPublisher === true}
                              onChange={(e) =>
                                setSoldByPublisher(e.target.checked)
                              }
                            />
                          }
                          label={`Sí, yo la ${
                            publicationData.statusCode === "Vendida"
                              ? "vendí"
                              : "alquilé"
                          }`}
                        />
                      </FormGroup>
                      <Typography variant="body2" sx={{ mt: 1, ml: 1 }}>
                        {soldByPublisher === true
                          ? `Se marcará como ${publicationData.statusCode.toLowerCase()} por ti.`
                          : `Se marcará como ${publicationData.statusCode.toLowerCase()} sin asignar a nadie (Broker).`}
                      </Typography>
                    </FormControl>
                  )}
                </FormControl>
              </Box>
            </Box>
          )}

          {selectedSection === "Título" && (
            <Box
              sx={{
                width: { xs: "80%", md: "100%" },
                maxWidth: "600px",
              }}
            >
              <Typography variant="h5" sx={{ mb: 2 }}>
                Editar Título
              </Typography>
              <TextField
                label="Título"
                variant="outlined"
                fullWidth
                multiline
                rows={4}
                value={publicationData.title}
                onChange={(e) =>
                  setPublicationData({
                    ...publicationData,
                    title: e.target.value,
                  })
                }
                sx={{
                  mt: 2,
                  backgroundColor: "white",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "darkgreen",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "darkgreen",
                    },
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#ccc",
                  },
                  "& .MuiInputLabel-root": {
                    "&.Mui-focused": {
                      color: "darkgreen",
                    },
                  },
                }}
              />
            </Box>
          )}
          {selectedSection === "Descripción" && (
            <Box
              sx={{
                width: { xs: "80%", md: "100%" },
                maxWidth: "600px",
              }}
            >
              <Typography variant="h5" sx={{ mb: 2 }}>
                Editar Descripción
              </Typography>
              <TextField
                label="Descripción"
                variant="outlined"
                fullWidth
                multiline
                minRows={6}
                value={publicationData.description}
                onChange={(e) =>
                  setPublicationData({
                    ...publicationData,
                    description: e.target.value,
                  })
                }
                sx={{
                  mt: 2,
                  backgroundColor: "white",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "darkgreen",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "darkgreen",
                    },
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#ccc",
                  },
                  "& .MuiInputLabel-root": {
                    "&.Mui-focused": {
                      color: "darkgreen",
                    },
                  },
                }}
              />
            </Box>
          )}
          {selectedSection === "Categoría" && (
            <Box sx={{ width: { xs: "80%", md: "100%" }, maxWidth: "600px" }}>
              <Typography variant="h5" sx={{ mb: 2 }}>
                Editar Categoría
              </Typography>
              <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                <InputLabel id="category-select-label">Categoría</InputLabel>
                <Select
                  labelId="category-select-label"
                  value={publicationData.category}
                  onChange={(e) =>
                    setPublicationData({
                      ...publicationData,
                      category: e.target.value,
                    })
                  }
                  label="Categoría"
                  sx={{
                    mt: 2,
                    backgroundColor: "white",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "darkgreen",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "darkgreen",
                      },
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#ccc",
                    },
                    "& .MuiInputLabel-root": {
                      "&.Mui-focused": {
                        color: "darkgreen",
                      },
                    },
                  }}
                >
                  {categories.map((category) => (
                    <MenuItem key={category.name} value={category.name}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        {category.icon}
                        <Typography sx={{ ml: 1 }}>{category.name}</Typography>
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          )}
          {selectedSection === "Tipo" && (
            <Box
              sx={{
                width: { xs: "80%", md: "100%" },
                maxWidth: "600px",
              }}
            >
              <Typography variant="h5" sx={{ mb: 2 }}>
                Editar Tipo
              </Typography>
              <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                <InputLabel id="type-select-label">Tipo</InputLabel>
                <Select
                  labelId="type-select-label"
                  value={publicationData.type}
                  onChange={(e) =>
                    setPublicationData({
                      ...publicationData,
                      type: e.target.value,
                    })
                  }
                  label="Tipo"
                  sx={{
                    mt: 2,
                    backgroundColor: "white",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "darkgreen",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "darkgreen",
                      },
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#ccc",
                    },
                    "& .MuiInputLabel-root": {
                      "&.Mui-focused": {
                        color: "darkgreen",
                      },
                    },
                  }}
                >
                  <MenuItem value="Alquiler">Alquiler</MenuItem>
                  <MenuItem value="Venta">Venta</MenuItem>
                </Select>
              </FormControl>
            </Box>
          )}
          {selectedSection === "Ubicación" && (
            <Box
              sx={{
                width: { xs: "80%", md: "100%" },
                maxWidth: "600px",
              }}
            >
              <Typography variant="h5" sx={{ mb: 2 }}>
                Editar Ubicación
              </Typography>
              <MapContainer
                center={selectedLocation}
                zoom={13}
                style={{ height: "400px", width: "100%" }}
              >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                <MapComponent
                  position={selectedLocation}
                  onMarkerDragEnd={handleMarkerDragEnd}
                />
              </MapContainer>
              <Box
                mt={2}
                mb={12}
                p={2}
                sx={{ borderRadius: 1, boxShadow: 3, flexGrow: 1 }}
              >
                <Box mb={2}>
                  <TextField
                    label="País/región"
                    variant="outlined"
                    fullWidth
                    value={formValues.country}
                    InputProps={{ readOnly: readOnlyState.country }}
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="Punto de referencia cercano (si lo hay)"
                    variant="outlined"
                    fullWidth
                    value={formValues.nearbyLandmark || ""}
                    onChange={handleChange}
                    name="nearbyLandmark"
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="Dirección"
                    variant="outlined"
                    fullWidth
                    value={formValues.streetAddress}
                    InputProps={{ readOnly: readOnlyState.streetAddress }}
                    onChange={handleChange}
                    name="streetAddress"
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="Apartamento, piso, edificio (si corresponde)"
                    variant="outlined"
                    fullWidth
                    value={formValues.apartment || ""}
                    onChange={handleChange}
                    name="apartment"
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="Departamento/estado/provincia/región"
                    variant="outlined"
                    fullWidth
                    value={formValues.province}
                    InputProps={{ readOnly: readOnlyState.province }}
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="Cantón"
                    variant="outlined"
                    fullWidth
                    value={formValues.county}
                    InputProps={{ readOnly: readOnlyState.county }}
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="Distrito"
                    variant="outlined"
                    fullWidth
                    value={addressDetails.district}
                    InputProps={{ readOnly: readOnlyState.district }}
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="Barrio"
                    variant="outlined"
                    fullWidth
                    value={formValues.neighborhood || ""}
                    InputProps={{ readOnly: readOnlyState.neighborhood }}
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="Zona"
                    variant="outlined"
                    fullWidth
                    value={
                      addressDetails.zone ||
                      selectedProperty?.zone ||
                      "No disponible"
                    }
                    InputProps={{ readOnly: readOnlyState.zone }}
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="Código postal"
                    variant="outlined"
                    fullWidth
                    value={formValues.postalCode}
                    InputProps={{ readOnly: readOnlyState.postalCode }}
                    sx={{ mb: 2 }}
                  />
                </Box>
              </Box>
            </Box>
          )}
          {selectedSection === "Precio" && (
            <Box
              sx={{
                width: { xs: "80%", md: "100%" },
                maxWidth: "600px",
              }}
            >
              <Typography variant="h5" sx={{ mb: 2 }}>
                Editar Precio
              </Typography>
              <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                <InputLabel id="type-select-label">Precio</InputLabel>
                <Select
                  value={propertyCurrency}
                  onChange={handleCurrencyChange}
                  sx={{
                    backgroundColor: "#f5f5f5",
                    borderRadius: "4px",
                    borderColor: "green",
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "green",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "green",
                    },
                    "& .MuiSelect-select": {
                      padding: "10px",
                      fontSize: "1rem",
                    },
                  }}
                >
                  <MenuItem
                    value="CRC"
                    sx={{
                      "&:hover": {
                        backgroundColor: "rgba(0, 128, 0, 0.1)",
                      },
                      "&.Mui-selected": {
                        backgroundColor: "rgba(0, 128, 0, 0.2)",
                      },
                      "&.Mui-selected:hover": {
                        backgroundColor: "rgba(0, 128, 0, 0.25)",
                      },
                    }}
                  >
                    Colones (₡)
                  </MenuItem>
                  <MenuItem
                    value="USD"
                    sx={{
                      "&:hover": {
                        backgroundColor: "rgba(0, 128, 0, 0.1)",
                      },
                      "&.Mui-selected": {
                        backgroundColor: "rgba(0, 128, 0, 0.2)",
                      },
                      "&.Mui-selected:hover": {
                        backgroundColor: "rgba(0, 128, 0, 0.25)",
                      },
                    }}
                  >
                    Dólares ($)
                  </MenuItem>
                </Select>
              </FormControl>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: 4,
                  px: { xs: 2, sm: 4 },
                }}
              >
                {isEditing ? (
                  <input
                    type="text"
                    value={propertyPrice}
                    onChange={handlePriceChange}
                    onBlur={handleBlur}
                    inputMode="numeric"
                    autoFocus
                    style={{
                      fontSize: "clamp(2rem, 8vw, 5rem)",
                      fontWeight: "bold",
                      textAlign: "center",
                      border: "none",
                      outline: "none",
                      width: "100%",
                      maxWidth: "500px",
                    }}
                  />
                ) : (
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: "bold",
                      fontSize: "clamp(2rem, 8vw, 5rem)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      cursor: "pointer",
                      flexWrap: "wrap",
                    }}
                    onClick={toggleEditing}
                  >
                    {formatPrice(propertyPrice, propertyCurrency)}
                    <IconButton size="small" sx={{ ml: 1 }}>
                      <EditIcon />
                    </IconButton>
                  </Typography>
                )}
              </Box>
            </Box>
          )}
          {selectedSection === "Servicios" && (
            <Box sx={{ width: { xs: "80%", md: "100%" }, maxWidth: "600px" }}>
              <Typography variant="h5" sx={{ mb: 2 }}>
                Editar Servicios
              </Typography>

              {/* Chips for Services */}
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 4,
                  mt: 4,
                  mb: 10,
                }}
              >
                {services.map((service) => {
                  const isSelected = publicationData.services.includes(
                    service.id
                  );
                  return (
                    <Chip
                      key={service.id}
                      icon={service.icon}
                      label={service.label}
                      color={isSelected ? "success" : "default"}
                      onClick={() => handleToggleService(service.id)}
                      variant={
                        publicationData.services.includes(service.id)
                          ? "filled"
                          : "outlined"
                      }
                      sx={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        padding: "20px",
                        cursor: "pointer",
                        borderRadius: "8px",
                        "&:hover": {
                          backgroundColor: isSelected
                            ? "rgba(76, 175, 80, 0.9)"
                            : "rgba(0, 0, 0, 0.4)",
                          transform: "scale(1.05)",
                        },
                        "& .MuiChip-icon": {
                          transition: "0.3s",
                          transform: isSelected ? "scale(1.1)" : "scale(1)",
                          color: isSelected ? "white" : "gray",
                        },
                      }}
                    />
                  );
                })}
              </Box>
            </Box>
          )}
          {selectedSection === "Amenidades" && (
            <Box sx={{ width: { xs: "80%", md: "100%" }, maxWidth: "600px" }}>
              <Typography variant="h5" sx={{ mb: 2 }}>
                Editar Amenidades
              </Typography>

              {/* Chips for Amenities */}
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 4,
                  mt: 4,
                  mb: 10,
                }}
              >
                {amenities.map((amenitie) => {
                  const isSelected = publicationData.amenities.includes(
                    amenitie.id
                  );
                  return (
                    <Chip
                      key={amenitie.id}
                      icon={amenitie.icon}
                      label={amenitie.label}
                      color={isSelected ? "success" : "default"}
                      onClick={() => handleToggleAmenitie(amenitie.id)}
                      variant={
                        publicationData.amenities.includes(amenitie.id)
                          ? "filled"
                          : "outlined"
                      }
                      sx={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        padding: "20px",
                        cursor: "pointer",
                        borderRadius: "8px",
                        "&:hover": {
                          backgroundColor: isSelected
                            ? "rgba(76, 175, 80, 0.9)"
                            : "rgba(0, 0, 0, 0.4)",
                          transform: "scale(1.05)",
                        },
                        "& .MuiChip-icon": {
                          transition: "0.3s",
                          transform: isSelected ? "scale(1.1)" : "scale(1)",
                          color: isSelected ? "white" : "gray",
                        },
                      }}
                    />
                  );
                })}
              </Box>
            </Box>
          )}
          {selectedSection === "Dimensión" && (
            <Box
              sx={{
                width: { xs: "80%", md: "100%" },
                maxWidth: "600px",
              }}
            >
              <Typography variant="h5" sx={{ mb: 2 }}>
                Editar Dimensión
              </Typography>
              <TextField
                label="Dimensión"
                type="number"
                variant="outlined"
                fullWidth
                value={publicationData.dimension}
                onChange={(e) => {
                  const value = parseFloat(e.target.value);
                  if (value >= 0) {
                    setPublicationData({
                      ...publicationData,
                      dimension: value,
                    });
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">m²</InputAdornment>
                  ),
                }}
                sx={{
                  mt: 2,
                  backgroundColor: "white",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "darkgreen",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "darkgreen",
                    },
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#ccc",
                  },
                  "& .MuiInputLabel-root": {
                    "&.Mui-focused": {
                      color: "darkgreen",
                    },
                  },
                }}
              />
            </Box>
          )}

          {selectedSection === "Visibilidad" && (
            <Box
              sx={{
                width: { xs: "80%", md: "100%" },
                maxWidth: "600px",
              }}
            >
              <Typography variant="h5" sx={{ mb: 2 }}>
                Editar Visibilidad
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: "white",
                  borderRadius: "12px",
                  border: "1px solid gray",
                  boxShadow: "0px 4px 8px rgba(0, 128, 0, 0.1)",
                  padding: "24px",
                  mt: 5,
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    mb: 4,
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  Visibilidad actual:{" "}
                  <strong
                    style={{
                      color: "green",
                    }}
                  >
                    {publicationData.visibility}
                  </strong>
                </Typography>

                <FormControl component="fieldset" fullWidth>
                  <FormLabel
                    component="legend"
                    sx={{
                      fontWeight: "bold",
                      mb: 2,
                      "&.Mui-focused": {
                        color: "inherit",
                      },
                    }}
                  >
                    Cambiar visibilidad a:
                  </FormLabel>
                  <RadioGroup
                    aria-label="visibilidad-publicacion"
                    value={publicationData.visibility}
                    onChange={handleVisibilityChange}
                  >
                    {/* Opción "Disponible" */}
                    <FormControlLabel
                      value="Pública"
                      control={
                        <Radio
                          sx={{
                            color: "green",
                            "&.Mui-checked": { color: "green" },
                          }}
                        />
                      }
                      label="Pública"
                    />

                    {/* Opción "Vendida" */}
                    <FormControlLabel
                      value="Privada"
                      control={
                        <Radio
                          sx={{
                            color: "green",
                            "&.Mui-checked": { color: "green" },
                          }}
                        />
                      }
                      label="Privada"
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
            </Box>
          )}
          {selectedSection === "Hunter" && (
            <Box
              sx={{
                width: { xs: "80%", md: "100%" },
                maxWidth: "600px",
              }}
            >
              <Typography variant="h5" sx={{ mb: 2 }}>
                Hunter Asignado
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: "white",
                  borderRadius: "12px",
                  border: "1px solid gray",
                  boxShadow: "0px 4px 8px rgba(0, 128, 0, 0.1)",
                  padding: "24px",
                  mt: 5,
                }}
              >
                {isLoadingHunters ? (
                  <Typography>Cargando hunters...</Typography>
                ) : (
                  <>
                    <FormControl fullWidth variant="outlined" sx={{ mb: 3 }}>
                      <InputLabel id="hunter-select-label">
                        Seleccionar Hunter
                      </InputLabel>
                      <Select
                        labelId="hunter-select-label"
                        value={publicationData.hunter || ""}
                        onChange={handleHunterChange}
                        label="Seleccionar Hunter"
                        sx={{
                          backgroundColor: "white",
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "8px",
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "darkgreen",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "darkgreen",
                            },
                          },
                        }}
                      >
                        {availableHunters.map((hunter) => (
                          <MenuItem key={hunter.id} value={hunter.id}>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              {hunter.profileImage && (
                                <Box
                                  component="img"
                                  src={hunter.profileImage}
                                  alt={`Hunter ${hunter.id}`}
                                  sx={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                    mr: 2,
                                    objectFit: "cover",
                                  }}
                                />
                              )}
                              <Box>
                                <Typography variant="body1">
                                  {hunter.contacts?.fullName ||
                                    `Hunter ${hunter.id}`}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Rating: {hunter.rating} | Propiedades:{" "}
                                  {hunter.propertiesUploadedCount}
                                </Typography>
                              </Box>
                            </Box>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    {publicationData.hunter! > 0 && (
                      <Box sx={{ textAlign: "center", mt: 2 }}>
                        <Typography
                          variant="body1"
                          sx={{ fontWeight: "bold", color: "green" }}
                        >
                          Hunter asignado actualmente: ID{" "}
                          {publicationData.hunter}
                        </Typography>
                        {availableHunters.find(
                          (h) => h.id === publicationData.hunter
                        ) && (
                          <Typography variant="body2">
                            {availableHunters.find(
                              (h) => h.id === publicationData.hunter
                            )?.contacts?.fullName ||
                              `Hunter ${publicationData.hunter}`}
                          </Typography>
                        )}
                      </Box>
                    )}
                  </>
                )}
              </Box>
            </Box>
          )}
          {selectedSection === "Redes sociales" && (
            <Box
              sx={{
                width: { xs: "80%", md: "100%" },
                maxWidth: "600px",
              }}
            >
              <Typography variant="h5" sx={{ mb: 2 }}>
                Editar Redes Sociales
              </Typography>

              {/* Campo para Facebook */}
              <TextField
                label="URL de Facebook"
                variant="outlined"
                fullWidth
                value={publicationData.facebookUrl || ""}
                onChange={(e) => {
                  setPublicationData({
                    ...publicationData,
                    facebookUrl: e.target.value,
                  });
                }}
                placeholder="https://facebook.com/tu-perfil"
                sx={{
                  mt: 2,
                  backgroundColor: "white",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#1877F2",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#1877F2",
                    },
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#ccc",
                  },
                  "& .MuiInputLabel-root": {
                    "&.Mui-focused": {
                      color: "#1877F2",
                    },
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img
                        src="/assets/images/facebook-icon.png"
                        alt="Facebook"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </InputAdornment>
                  ),
                }}
              />

              {/* Campo para Instagram */}
              <TextField
                label="URL de Instagram"
                variant="outlined"
                fullWidth
                value={publicationData.instagramUrl || ""}
                onChange={(e) => {
                  setPublicationData({
                    ...publicationData,
                    instagramUrl: e.target.value,
                  });
                }}
                placeholder="https://instagram.com/tu-perfil"
                sx={{
                  mt: 3,
                  backgroundColor: "white",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#E1306C", // Rosa de Instagram
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#E1306C",
                    },
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#ccc",
                  },
                  "& .MuiInputLabel-root": {
                    "&.Mui-focused": {
                      color: "#E1306C",
                    },
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img
                        src="/assets/images/insta-icon.png"
                        alt="Instagram"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </InputAdornment>
                  ),
                }}
              />

              {/* Mensaje de ayuda */}
              <Typography
                variant="body2"
                sx={{ mt: 2, color: "text.secondary" }}
              >
                Ingresa la URL completa (ej: https://facebook.com/tu-perfil)
              </Typography>
            </Box>
          )}
          {selectedSection === "Documentos y Dueños" && (
            <DocumentsScreen
              propertyId={selectedProperty?.id_Property}
              onDataChange={handleDocumentDataChange}
              validationErrors={documentValidationErrors}
              showValidation={showDocumentValidation}
            />
          )}
          {selectedSection === "Solicitudes de colaboración" && (
            <CollaborationRequestsSection selectedProperty={selectedProperty} />
          )}
          {selectedSection === "Comisión" && (
            <EditCommissionPage selectedProperty={selectedProperty}/>
          )}
          {selectedSection === "Ofertas" && (
            <PropertyOfferPage selectedProperty={selectedProperty} onPromotionUpdate={onPromotionUpdate} />
          )}
          {selectedSection === "Cupones" && (
            <PropertyCouponPage property={selectedProperty!} onCouponUpdate={() => {}} />
          )}
        </Box>
      </Box>

      <Button
        variant="contained"
        color="success"
        disabled={isLoading}
        onClick={handleSaveChanges}
        startIcon={<SaveIcon sx={{ fontSize: 20 }} />}
        sx={{
          position: "fixed",
          bottom: { xs: 100, sm: 16 },
          right: 16,
          borderRadius: 10,
          padding: "10px 20px",
          fontSize: "1rem",
        }}
      >
        {isLoading ? "Guardando..." : "Guardar"}
      </Button>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Box
        sx={{
          height: "80px",
          display: { xs: "block", sm: "none" },
          width: "100%",
        }}
      />
    </Box>
  );
};

export default EditPublication;
